/** @format */

import React, { Component } from 'react';
import { Search } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';

@inject('ClientsStore')
@observer
class ClientQuickSearch extends Component {
  render() {
    const { ClientsStore } = this.props;
    const results = ClientsStore.clientsParams.quickSearchResults;

    return (
      <Search
        loading={ClientsStore.fetching.clients.loading}
        onSearchChange={(e, result) =>
          ClientsStore.handleClientSearch(result.value.trim())
        }
        className="client-search"
        size="small"
        onResultSelect={(e, selected) =>
          ClientsStore.handleSelectClient(selected.result.id)
        }
        results={results}
        placeholder="Cerca Cliente"
        noResultsMessage="Nessun cliente trovato"
        fluid
      />
    );
  }
}

export default ClientQuickSearch;
